import * as React from "react"
import { actions, AppState } from "../data/redux-state"
import { FormattedMessage, IntlShape, useIntl } from "gatsby-plugin-intl"
import { globalStore } from "./Index"
import { extractOptionalTranslation } from "../utils/extractOptionalTranslation"
import OutlinedInput from "@mui/material/OutlinedInput"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import checkSubVars from "../utils/checkSubVars"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export function extractHumanReadableSubVar(subVar: string, intl: IntlShape) {
  if (!subVar) {
    return ""
  }
  return extractOptionalTranslation({
    parentKey: "subVariableNames",
    subKey: subVar,
    intl,
  })
}

function getSubVariables(appState: AppState) {
  const sourceJson = appState.sourceJson
  if (!sourceJson) {
    return { subVariablesData: [], subVariables: [] }
  }
  const subVariables = []
  const subVariablesData = []
  const mainSubvars = checkSubVars(sourceJson)
  for (let name in mainSubvars) {
    subVariables.push(name)
    subVariablesData.push(mainSubvars[name])
  }
  return { subVariablesData, subVariables }
}

export const MultiSubvariablesDropdown = (props: AppState) => {
  const intl = useIntl()

  const { subVariablesData, subVariables } = getSubVariables(props)

  const [selectedSubvariables, setSelectedSubvariables] = React.useState(
    props.subVariable
  )

  React.useEffect(() => {
    setSelectedSubvariables(props.subVariable)
  }, [props.geoRegion])

  const handleChange = (event: any) => {
    const subVars: [string] | [] = event.target.value
    globalStore.dispatch(actions.setSubVariable({ subVars, intl }))
  }

  return (
    <FormControl style={{ width: "80%", marginTop: "10px" }}>
      <InputLabel
        style={{ backgroundColor: "white", left: "-13px" }}
        id="subvariable-native-helper"
      >
        <FormattedMessage id={"dropdown.selectSubVar"} />
      </InputLabel>
      <Select
        value={props.subVariable ?? []}
        onChange={handleChange}
        //   labelId="demo-multiple-name-label"
        id="subvariable-native-helper"
        name="subvariable"
        multiple
        input={<OutlinedInput label="Region" />}
        MenuProps={MenuProps}
        style={{ textAlign: "left", paddingLeft: 0 }}
      >
        {subVariablesData.map((subvar, index) => {
          return (
            <MenuItem
              key={subVariables[index]}
              value={subVariables[index]}

              // style={getStyles(subvar, props.subvariable, theme)}
            >
              {extractHumanReadableSubVar(
                subvar.Metadata.SubVariableName,
                intl
              )}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
